<template>
    <div>
        <div>
            <el-radio v-model="radio" @change="fix(1)" label="1">  我可提供身份证原件，稍后与客服进行视频认证.</el-radio>
        </div>
        <div style="margin-top:15px;">
            <el-radio v-model="radio" label="2"  @change="fix(2)">  直接在表单中提交帐号新的身份证正反扫描件、</br></br>手持身份证正面和脸部都清晰的合影以及个人上半身照</el-radio>
        </div>
        <div v-if="radio==2">
            <h3>样图</h3>
            <div>
                <p>
                    <img src="http://kf.zhaouc.com/1-1F401092526.jpg">
                </p>
                <p>
                    <img src="http://kf.zhaouc.com/1-1F401092527.jpg">
                </p>
                <p>
                    <img src="http://kf.zhaouc.com/1-1F401092529-50.jpg">
                </p>
                <p>
                    <img src="http://kf.zhaouc.com/1-1F401092529.jpg">
                </p>
            </div>
        </div>
        <template v-if="radio==2">
            <el-upload
                    class="upload-demo"
                    action="/index.php/user/User/uploadwater"
                    name="image"
                    :on-success="handleSuccess"
                    :on-remove="handleRemove"
                    :before-remove="beforeRemove"
                    :file-list="fileList">
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过4MB</div>
            </el-upload>
        </template>

    </div>
</template>

<script >
  export default {
	props: ['cl'],
    name: "FontOnlyUpload",
    data(){
      return {
        fileList:[],
        radio:'1',
        img_list:[]
      }
    },
	watch: {
	    cl(newValue, oldValue) {
			if(newValue){
				console.log(newValue)
				this.fileList=[]
				this.img_list=[]
			}
	    }
	},
    methods:{
      handleSuccess(response, file, fileList) {
		this.cl=false;
        if( this.radio='2'){
          if(response.status!=200){
            this.$message({
              type: 'error',
              message:"非法图片",
			  offset:300
            });
            this.fileList=fileList.slice(0,-1);
            return false
          }
          // @ts-ignore
          this.img_list.push(response.data);
          this.$emit('input',JSON.stringify(this.img_list));
        }
      },
      handleRemove(file,fileList) {
        // @ts-ignore
        this.img_list.splice(this.img_list.indexOf(file.response.data),1);
		this.$emit('input',JSON.stringify(this.img_list));
      },
      beforeRemove(file) {
        return this.$confirm(`确定移除 ${ file.name }?`);
      },
      fix(num){
        if(num=='1'){
          this.$emit('input',"视频验证");
          this.fileList=[];
        }else{
          this.$emit('input',"");
        }
      }
    },
    created(){
      this.fix("1");
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped >
    .w-g-information img{max-width:400px}
</style>



// WEBPACK FOOTER //
// src/components/Font-upload.vue